export default {
    translations: {
        
           Title: 'English',
           About: 'Biog',
           Projects: 'Projects',
           Recordings: 'Recordings',
           Media: 'Media',
           Calendar: 'Calendar',
           Press: 'Press',
           Archive: 'Archive',
           Contact: 'Contact',
           ContactText: 'I would love to hear from you',
           News: 'News',
           RecordingInfo: 'Violin concerti H.-J. De Croes. Coming soon!',
           FormText: 'Subscribe to our newsletter',
           FormName: 'Name and surname',
           FormEmail: 'Email',
           PrivacyAgreed1: 'I agree to the ',
           PrivacyAgreed2: ' privacy policy (GDPR)',
           FormButton: 'Register',
           Privacy: 'Click here to read our privacy policy',
           Close:'close',
           ViewConcert: 'find out more',
           Photos: 'All photographs © ',
           Violin: 'violin',
           ToAllRecordings: 'to all recordings',
           ToAllVideos: 'to all videos'
          }
          
    
}